module.exports = __webpack_public_path__ + "static/media/soul-cloud-right.4bd51ffa.svg";